import React from "react";

import styles from "./ForbiddenPage.module.scss";

const ForbiddenPage = () => <h1 className={styles.title}>У вас нет доступа к данной странице</h1>;

export default React.memo(ForbiddenPage);
